var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchablePartsList',{attrs:{"title":_vm.searchBoxTitle,"partActionLink":_vm.partActionLink,"showPartImages":true,"parts":_vm.filteredParts},on:{"search-term-changed":_vm.onSearchTextChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }